import { createReducer, createActions } from "reduxsauce";
import Immutable from "seamless-immutable";
import { isNull, isUndefined, cloneDeep } from "lodash";

// Commenting out missing action type imports
// import { ActionTypes as AdminActionTypes } from "./actionTypes/layouts/AdminActionTypes";
// import { ActionTypes as RegisterPartnerActionTypes } from "./actionTypes/screens/account/RegisterPartnerActionTypes";
// import { ActionTypes as LoginActionTypes } from "./actionTypes/screens/account/LoginActionTypes";
// import { ActionTypes as UserLoginActionTypes } from "./actionTypes/screens/account/UserLoginActionTypes";
// import { ActionTypes as UserRegisterActionTypes } from "./actionTypes/screens/account/UserRegisterActionTypes";
// import { ActionTypes } from "./actionTypes/SessionActionTypes";

import AppConfig from "../config/AppConfig";
import StorageEngine from "../utils/StorageEngine";
import Constants from "../config/Constants";
import { ActionTypes as LoginActionTypes } from "./actionTypes/screens/account/LoginActionTypes";
import { ActionTypes as ChooseRegionActionTypes } from "./actionTypes/screens/admin/ChooseRegionActionTypes";
import { ActionTypes as DefaultActionTypes } from "./actionTypes/screens/DefaultActionTypes";
import { ActionTypes as ProfileActionTypes } from "./actionTypes/screens/admin/ProfileActionTypes";

// Define ActionTypes here since the import is missing
const ActionTypes = {
    TRY_LOAD_SESSION: "TRY_LOAD_SESSION",
    LOGOUT: "LOGOUT",
    RECEIVE_REFRESHED_TOKEN: "RECEIVE_REFRESHED_TOKEN",
    SWITCH_BACK_TO_SUPER_ADMIN: "SWITCH_BACK_TO_SUPER_ADMIN",
    SWITCH_BACK_TO_AGENT: "SWITCH_BACK_TO_AGENT",
    SWITCH_BACK_TO_TEACHER: "SWITCH_BACK_TO_TEACHER",
    UPDATE_SPECIFIC_PENDING_REQUEST: "UPDATE_SPECIFIC_PENDING_REQUEST",
    UPDATE_PENDING_REQUESTS_FROM_RESPONSE: "UPDATE_PENDING_REQUESTS_FROM_RESPONSE",
    UPDATE_MY_PENDING_REQUESTS: "UPDATE_MY_PENDING_REQUESTS",
    UPDATE_SPECIFIC_MY_PENDING_REQUEST: "UPDATE_SPECIFIC_MY_PENDING_REQUEST",
    UPDATE_SELECTED_STORE: "UPDATE_SELECTED_STORE",
};

//
// Actions
//
const Actions = {
    tryLoadSession: () => ({
        type: ActionTypes.TRY_LOAD_SESSION,
    }),

    logout: () => ({
        type: ActionTypes.LOGOUT,
    }),

    receiveRefreshedToken: (data) => ({
        type: ActionTypes.RECEIVE_REFRESHED_TOKEN,
        data,
    }),

    switchBackToSuperAdmin: (data) => ({
        type: ActionTypes.SWITCH_BACK_TO_SUPER_ADMIN,
        data,
    }),

    switchBackToAgent: (data, isLoginFromAdminStatic, superAdminBackupData) => ({
        type: ActionTypes.SWITCH_BACK_TO_AGENT,
        data,
        isLoginFromAdminStatic,
        superAdminBackupData,
    }),

    switchBackToTeacher: (data, isLoginFromAdminStatic, superAdminBackupData, isLoginFromAgent, agentBackupData) => ({
        type: ActionTypes.SWITCH_BACK_TO_TEACHER,
        data,
        isLoginFromAdminStatic,
        superAdminBackupData,
        isLoginFromAgent,
        agentBackupData,
    }),

    updateSpecificPendingRequest: (requestType, count) => ({
        type: ActionTypes.UPDATE_SPECIFIC_PENDING_REQUEST,
        requestType,
        count,
    }),

    updatePendingRequestsFromResponse: (pendingRequests) => ({
        type: ActionTypes.UPDATE_PENDING_REQUESTS_FROM_RESPONSE,
        pendingRequests,
    }),

    updateMyPendingRequests: (myPendingRequests) => ({
        type: ActionTypes.UPDATE_MY_PENDING_REQUESTS,
        myPendingRequests,
    }),

    updateSpecificMyPendingRequest: (requestType, count) => ({
        type: ActionTypes.UPDATE_SPECIFIC_MY_PENDING_REQUEST,
        requestType,
        count,
    }),

    updateSelectedStore: (storeId) => ({
        type: ActionTypes.UPDATE_SELECTED_STORE,
        storeId,
    }),
};



/* ------------- Initial State ------------- */
const INITIAL_STATE = {
    user: null,
    authorization: null,
    userId: null,
    isLoginFromSuperAdmin: false,
    superAdminBackupData: null,
    agentBackupData: null,
    teacherBackupData: null,
    region: null,
    regionList: null,
    activeRegionList: null,
    regionId: null,
    storeId: null,
    storeList: null,
    enableStoreOperation: false,
    pendingRequests: {
        pendingRegionJoinRequestCount: 0,
        pendingConsumerServiceRequestCount: 0,
        pendingConsumerReviewRequestCount: 0,
        pendingProviderReviewRequestCount: 0,
        pendingConsumerReportRequestCount: 0,
        pendingConsumerWithdrawalRequestCount: 0,
        pendingProviderWithdrawalRequestCount: 0,
        pendingMarketerWithdrawalRequestCount: 0,
        pendingRegionWithdrawalRequestCount: 0,
        pendingAgentWithdrawalRequestCount: 0,
        pendingFeedbackRequestCount: 0,
        pendingCancelReservationWithoutLiabilityRequestCount: 0,
        pendingReservationRewardPenaltyRequestCount: 0,
        pendingAbnormalReservationRequestCount: 0,
        pendingProviderRegisterCount: 0,
        pendingProviderLevelEvaluationCount: 0,
        pendingUserAuthenticationCount: 0,
        pendingFreeReservationRequestCount: 0,
        pendingProviderRejectReservationRequestCount: 0,
        pendingAgentRegisterCount: 0,
        pendingConsumerRegisterCount: 0,
        pendingMarketerRegisterCount: 0,
        pendingTeamCertificationRequestCount: 0,
        pendingStoreJoinRequestCount: 0,
        pendingNewServiceTypeRequestCount: 0,
        pendingProviderStoreJoinRequestCount: 0,
        pendingStoreWithdrawalRequestCount: 0,
        pendingStoreAutomaticSettlementRequestCount: 0,
    },
    myPendingRequest: {
        pendingRegionJoinRequestCount: 0,
        pendingConsumerServiceRequestCount: 0,
        pendingConsumerReviewRequestCount: 0,
        pendingProviderReviewRequestCount: 0,
        pendingConsumerReportRequestCount: 0,
        pendingConsumerWithdrawalRequestCount: 0,
        pendingProviderWithdrawalRequestCount: 0,
        pendingMarketerWithdrawalRequestCount: 0,
        pendingRegionWithdrawalRequestCount: 0,
        pendingAgentWithdrawalRequestCount: 0,
        pendingFeedbackRequestCount: 0,
        pendingCancelReservationWithoutLiabilityRequestCount: 0,
        pendingReservationRewardPenaltyRequestCount: 0,
        pendingAbnormalReservationRequestCount: 0,
        pendingProviderRegisterCount: 0,
        pendingProviderLevelEvaluationCount: 0,
        pendingUserAuthenticationCount : 0,
        pendingFreeReservationRequestCount: 0,
        pendingMarketerRegisterCount: 0,
        pendingTeamCertificationRequestCount: 0,
        pendingStoreJoinRequestCount: 0,
        pendingNewServiceTypeRequestCount: 0,
        pendingStoreWithdrawalRequestCount: 0,
        pendingStoreAutomaticSettlementRequestCount: 0,
    },
};

/* ------------- Reducers ------------- */
// we've successfully logged in
const loginSuccessReducer = (state, { data }) => {
    const baseState = {
        user: data.user,
        authorization: data.authorization,
        userId: data.user.id,
        regionList: data.regionList,
        region: data.region,
        unitTaskParticipants: data.unitTaskParticipants,
        isLoginFromSuperAdmin: data.isLoginFromSuperAdmin,
        isLoginFromAgent: data.isLoginFromAgent,
        isLoginFromAdminStatic: data.isLoginFromAdminStatic,
        isLoginFromTeacher: data.isLoginFromTeacher,
        regionId: data.user.regionId,
        storeId: data.user.storeId,
        storeList: data.user.storeList || null,
        pendingRequests: data.pendingRequests || {
            pendingTodoTaskRequestCount: 0,
            pendingRegionJoinRequestCount: 0,
            pendingConsumerWithdrawalRequestCount: 0,
            pendingProviderWithdrawalRequestCount: 0,
            pendingMarketerWithdrawalRequestCount: 0,
            pendingRegionWithdrawalRequestCount: 0,
            pendingAgentWithdrawalRequestCount: 0,
            pendingTeamCertificationRequestCount: 0,
            pendingStoreJoinRequestCount: 0,
            pendingNewServiceTypeRequestCount: 0,
            pendingStoreWithdrawalRequestCount: 0,
            pendingStoreAutomaticSettlementRequestCount: 0,
        },
        // 同时获取myPendingRequest，避免循环依赖
        myPendingRequest: data.MyPendingRequests || {
            pendingRegionJoinRequestCount: 0,
            pendingConsumerServiceRequestCount: 0,
            pendingConsumerReviewRequestCount: 0,
            pendingProviderReviewRequestCount: 0,
            pendingConsumerReportRequestCount: 0,
            pendingConsumerWithdrawalRequestCount: 0,
            pendingProviderWithdrawalRequestCount: 0,
            pendingMarketerWithdrawalRequestCount: 0,
            pendingRegionWithdrawalRequestCount: 0,
            pendingAgentWithdrawalRequestCount: 0,
            pendingFeedbackRequestCount: 0,
            pendingCancelReservationWithoutLiabilityRequestCount: 0,
            pendingReservationRewardPenaltyRequestCount: 0,
            pendingAbnormalReservationRequestCount: 0,
            pendingProviderRegisterCount: 0,
            pendingProviderLevelEvaluationCount: 0,
            pendingUserAuthenticationCount: 0,
            pendingFreeReservationRequestCount: 0,
            pendingProviderRejectReservationRequestCount: 0,
            pendingAgentRegisterCount: 0,
            pendingConsumerRegisterCount: 0,
            pendingMarketerRegisterCount: 0,
            pendingTeamCertificationRequestCount: 0,
            pendingNewServiceTypeRequestCount: 0,
            pendingStoreJoinRequestCount: 0,
            pendingStoreWithdrawalRequestCount: 0,
            pendingStoreAutomaticSettlementRequestCount: 0,
        },
    };
    //只保留第一次的登录backupdata. 
    //超管登录区域管理员再登录员工.退回的时候退回到第一个.超管
    if (!state.superAdminBackupData) {
        if (data.isLoginFromSuperAdmin || data.isLoginFromAdminStatic) {
            baseState.superAdminBackupData = data.superAdminBackupData
                ? data.superAdminBackupData
                : { user: state.user, userId: state.userId, authorization: state.authorization, regionList: state.regionList, region: state.region, storeId: state.storeId, storeList: state.storeList};
        }
    }
    
    const newState = {
        ...baseState,
        agentBackupData: data.isLoginFromAgent
            ? data.agentBackupData
                ? data.agentBackupData
                : { user: state.user, userId: state.userId, authorization: state.authorization }
            : null,
        teacherBackupData: data.isLoginFromTeacher
            ? data.teacherBackupData
                ? data.teacherBackupData
                : { user: state.user, userId: state.userId, authorization: state.authorization }
            : null,
    };

    //save into storage
    StorageEngine(AppConfig.SESSION_STORAGE_KEY).save(newState);

    return { ...state, ...newState };
};

const logoutReducer = (state) => {
    //delete from store
    StorageEngine(AppConfig.SESSION_STORAGE_KEY).delete();
    // we need to keep some values like isConnected or else, so
    // here we only override necessary states when logout
    return { ...state, ...INITIAL_STATE };
};

const tryLoadSessionReducer = (state) => {
    const newState = StorageEngine(AppConfig.SESSION_STORAGE_KEY).load();
    if (!isNull(newState) && !isUndefined(newState)) {
        return { ...state, ...newState };
    } else {
        return state;
    }
};

const receiveRefreshedTokenReducer = (state, { data }) => {
    const newState = {
        authorization: { ...data },
    };

    //save into storage
    StorageEngine(AppConfig.SESSION_STORAGE_KEY).save({ ...state, ...newState });

    return { ...state, ...newState };
};

// we've successfully selected one partner
const selectRegionSuccessReducer = (state, { data }) => {
    const newState = {
        region: data,
        regionId: data?.id,
    };

    //save into storage
    StorageEngine(AppConfig.SESSION_STORAGE_KEY).save({ ...state, ...newState });

    return { ...state, ...newState };
};

const saveUserSuccessReducer = (state, { data }) => {
    if (!data || !state.user) {
        return state;
    }

    const updatedUser = {
        ...state.user,
        ...data,
        id: data.id || state.user.id,
        icon: data.icon
            ? { ...(state.user.icon || {}), ...data.icon }
            : state.user.icon,
    };

    const newState = {
        ...state,
        user: updatedUser,
        userId: updatedUser.id || state.userId,
    };

    StorageEngine(AppConfig.SESSION_STORAGE_KEY).save(newState);

    return newState;
};

const switchBackToSuperAdminReducer = (state, { data }) => {
    const newState = {
        ...data,
        user: data.user,
        userId: data.userId,
        authorization: data.authorization,
        superAdmin: true,
        isLoginFromSuperAdmin: false,
        isLoginFromAgent: false,
        isLoginFromAdminStatic: false,
        isLoginFromTeacher: false,
        regionList: data.regionList,
        region: null,
        regionId: null,
        storeId: null,
        storeList: data.storeList,
    };
    //save into storage
    StorageEngine(AppConfig.SESSION_STORAGE_KEY).save({ ...state, ...newState });

    return { ...state, ...newState };
};

const switchBackToAgentReducer = (state, { data, isLoginFromAdminStatic, superAdminBackupData }) => {
    const newState = {
        ...data,
        user: data.user,
        userId: data.userId,
        authorization: data.authorization,
        superAdmin: true,
        isLoginFromAgent: false,
        isLoginFromAdminStatic,
        superAdminBackupData,
        isLoginFromTeacher: false,
    };
    //save into storage
    StorageEngine(AppConfig.SESSION_STORAGE_KEY).save({ ...state, ...newState });

    return { ...state, ...newState };
};

const switchBackToTeacherReducer = (state, { data, isLoginFromAdminStatic, superAdminBackupData, isLoginFromAgent, agentBackupData }) => {
    const newState = {
        ...data,
        user: data.user,
        userId: data.userId,
        authorization: data.authorization,
        superAdmin: true,
        isLoginFromAgent,
        isLoginFromAdminStatic,
        superAdminBackupData,
        agentBackupData,
        isLoginFromTeacher: false,
    };

    //save into storage
    StorageEngine(AppConfig.SESSION_STORAGE_KEY).save({ ...state, ...newState });

    return { ...state, ...newState };
};

const loadAppSuccessReducer = (state, { data }) => {
    const newState = {
        activeRegionList: data.activeRegionList,
        enableStoreOperation: data.enableStoreOperation === undefined ? false : !!data.enableStoreOperation,
    };
    //save into storage
    StorageEngine(AppConfig.SESSION_STORAGE_KEY).save({ ...state, ...newState });

    return { ...state, ...newState };
};

const updateSpecificPendingRequestsReducer = (state, { requestType, count }) => {
    const newState = {
        ...state,
        pendingRequests: {
            ...state.pendingRequests,
            [requestType]: count,
        },
    };

    StorageEngine(AppConfig.SESSION_STORAGE_KEY).save({ ...state, ...newState });

    return { ...state, ...newState };
};

const updatePendingRequestsFromResponseReducer = (state, { pendingRequests }) => {
    const newState = {
        ...state,
        pendingRequests: pendingRequests,
    };

    StorageEngine(AppConfig.SESSION_STORAGE_KEY).save({ ...state, ...newState });

    return { ...state, ...newState };
};

const updateMyPendingRequestsReducer = (state, { myPendingRequests }) => {
    const newState = {
        ...state,
        myPendingRequest: myPendingRequests,
    };

    StorageEngine(AppConfig.SESSION_STORAGE_KEY).save({ ...state, ...newState });

    return { ...state, ...newState };
};

const updateSpecificMyPendingRequestsReducer = (state, { requestType, count }) => {
    const newState = {
        ...state,
        myPendingRequest: {
            ...state.myPendingRequest,
            [requestType]: count,
        },
    };

    StorageEngine(AppConfig.SESSION_STORAGE_KEY).save({ ...state, ...newState });

    return { ...state, ...newState };
};

const updateSelectedStoreReducer = (state, { storeId }) => {
    const newState = {
        ...state,
        storeId,
    };

    StorageEngine(AppConfig.SESSION_STORAGE_KEY).save({ ...state, ...newState });

    return { ...state, ...newState };
};

/* ------------- Hookup Reducers To Types ------------- */

const reducer = createReducer(INITIAL_STATE, {
    // Commenting out reducers that use missing action types
    // [UserLoginActionTypes.LOGIN_SUCCESS]: loginSuccessReducer,
    // [RegisterPartnerActionTypes.REGISTER_PARTNER_SUCCESS]: loginSuccessReducer,
    // [RegisterPartnerActionTypes.LOGIN_SUCCESS]: loginSuccessReducer,
    // [UserRegisterActionTypes.REGISTER_SUCCESS]: loginSuccessReducer,
    // [UserRegisterActionTypes.LOGIN_SUCCESS]: loginSuccessReducer,
    [LoginActionTypes.LOGIN_SUCCESS]: loginSuccessReducer,
    //[RegisterPartnerActionTypes.ACTIVE_TEACHER_SUCCESS]: loginSuccessReducer,
    //[AdminActionTypes.SELECT_REGION]: selectPartnerSuccessReducer,
    [ChooseRegionActionTypes.SELECT_REGION]: selectRegionSuccessReducer,
    [DefaultActionTypes.LOAD_APP_SUCCESS]: loadAppSuccessReducer,
    [ActionTypes.TRY_LOAD_SESSION]: tryLoadSessionReducer,
    [ActionTypes.LOGOUT]: logoutReducer,
    [ActionTypes.RECEIVE_REFRESHED_TOKEN]: receiveRefreshedTokenReducer,
    [ActionTypes.SWITCH_BACK_TO_SUPER_ADMIN]: switchBackToSuperAdminReducer,
    [ActionTypes.SWITCH_BACK_TO_AGENT]: switchBackToAgentReducer,
    [ActionTypes.SWITCH_BACK_TO_TEACHER]: switchBackToTeacherReducer,
    [ActionTypes.UPDATE_SPECIFIC_PENDING_REQUEST]: updateSpecificPendingRequestsReducer,
    [ActionTypes.UPDATE_PENDING_REQUESTS_FROM_RESPONSE]: updatePendingRequestsFromResponseReducer,
    [ActionTypes.UPDATE_MY_PENDING_REQUESTS]: updateMyPendingRequestsReducer,
    [ActionTypes.UPDATE_SPECIFIC_MY_PENDING_REQUEST]: updateSpecificMyPendingRequestsReducer,
    [LoginActionTypes.CHANGE_PASSWORD_SUCCESS]: loginSuccessReducer,
    [ActionTypes.UPDATE_SELECTED_STORE]: updateSelectedStoreReducer,
    [ProfileActionTypes.SAVE_USER_SUCCESS]: saveUserSuccessReducer,
});

export { ActionTypes, Actions, reducer, INITIAL_STATE };

